import { render, staticRenderFns } from "./TestUploadImage2Sso.vue?vue&type=template&id=49f0548a&"
import script from "./TestUploadImage2Sso.vue?vue&type=script&lang=js&"
export * from "./TestUploadImage2Sso.vue?vue&type=script&lang=js&"
import style0 from "./TestUploadImage2Sso.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports